import _isEqual from "lodash/isEqual";
import _isNil from "lodash/isNil";
import createMemoizedSelector from 'redux/selectors/createMemoizedSelector';
import getAnalysisTool from 'redux/selectors/getAnalysisTool';
import { analysisTools } from 'const';
var getIsScanpySelector = function getIsScanpySelector() {
  return function (analysisTool) {
    if (_isNil(analysisTool)) return null;
    return _isEqual(analysisTool, analysisTools.SCANPY);
  };
};
export default createMemoizedSelector(getIsScanpySelector, {
  inputSelectors: getAnalysisTool()
});